import React from 'react'
import { Container, Grid, makeStyles } from '@material-ui/core'
import Page from '../../../components/Page'
import firebase from 'firebase/app'
import Budget from './Budget'
import LatestUsers from './LatestUsers'
import LatestReports from './LatestReports'
import Sales from './Sales'
import TasksProgress from './TasksProgress'
import TotalUsers from './TotalUsers'
import TotalProfit from './TotalProfit'
import UsersByCountry from './UsersByCountry'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}))

const Dashboard = () => {
    const classes = useStyles()
    const [userMetaData, setUserMetaData] = React.useState()

    async function getUserMetaData() {
        return firebase
            .firestore()
            .doc('metaData/users')
            .get()
            .then((res) => setUserMetaData(res.data()))
    }

    React.useEffect(() => {
        getUserMetaData()
    }, [])

    // function updateUserMetaData() {
    //   firebase
    //     .firestore()
    //     .collection(`users`)
    //     .get()
    //     .then(async (res) => {
    //       const data = {};

    //       // COUNT ALL USERS
    //       const userCount = res.docs.length;
    //       data.count = userCount;
    //       console.log('count:', userCount);
    //       // COUNT ALL ACTIVE USERS
    //       const active = [];
    //       res.forEach((gogo) => {
    //         const got = gogo.data();
    //         if (!got.disabled) {
    //           active.push(1);
    //         }
    //       });
    //       console.log('active', active.length);
    //       data.active = active.length;
    //       // COUNT COUNTRIES AND THEIR USERS
    //       const countries = [];
    //       res.forEach((gogo) => {
    //         const got = gogo.data();
    //         if (got.countryCode) {
    //           countries.push(got.countryCode);
    //         }
    //       });

    //       const uniqueItems = [...new Set(countries)];
    //       console.log(uniqueItems);

    //       uniqueItems.forEach((item) => {
    //         const countryUsers = countries.filter((country) => country === item);
    //         data[`${item}`] = countryUsers.length;
    //       });

    //       await firebase
    //         .firestore()
    //         .collection(`metaData`)
    //         .doc(`users`)
    //         .set(data);
    //     });
    // }

    // React.useEffect(() => updateUserMetaData(), []);

    return (
        <Page className={classes.root} title="Dashboard">
            <Container maxWidth={false}>
                <Grid container spacing={3}>
                    <Grid item lg={3} sm={6} xl={3} xs={12}>
                        <TotalUsers data={userMetaData} />
                    </Grid>
                    <Grid item lg={3} sm={6} xl={3} xs={12}>
                        <TasksProgress />
                    </Grid>
                    <Grid item lg={3} sm={6} xl={3} xs={12}>
                        <TotalProfit />
                    </Grid>
                    <Grid item lg={3} sm={6} xl={3} xs={12}>
                        <Budget />
                    </Grid>
                    <Grid item lg={4} md={4} xl={3} xs={12}>
                        <UsersByCountry data={userMetaData} />
                    </Grid>
                    <Grid item lg={8} md={8} xl={9} xs={12}>
                        <Sales />
                    </Grid>
                    <Grid item lg={6} md={6} xl={6} xs={12}>
                        <LatestReports />
                    </Grid>
                    <Grid item lg={6} md={6} xl={6} xs={12}>
                        <LatestUsers />
                    </Grid>
                </Grid>
            </Container>
        </Page>
    )
}

export default Dashboard
